import { utility } from '@phi/components';
import styles from './index.module.scss';
import { rem } from '@phi/util/css';
import { defineComponent, h } from 'vue';

export default defineComponent({
    props: {
        diameter: {
            required: false,
            type: String,
            default: rem(1),
        },

        color: {
            required: false,
            type: String,
            default: 'black',
        },

        inflates: {
            required: false,
            type: Boolean,
            default: false,
        },

        inflated: {
            required: false,
            type: Boolean,
            default: false,
        },
    },

    emits: {
        click: (x: MouseEvent) => true,
    },

    render() {
        return h('div', {
            class: {
                [utility.circular]: true,
                [styles.ball]: true,
                [styles.inflates]: this.inflates,
                [styles.inflated]: this.inflated,
            },
            style: {
                '--d': this.diameter,
                'background-color': this.color,
            },
            onClick: (e: MouseEvent) => this.$emit('click', e),
        });
    },
});
